/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactScriptManifest } from './ContactScriptManifest.js';
import {
    ContactScriptManifestFromJSON,
    ContactScriptManifestFromJSONTyped,
    ContactScriptManifestToJSON,
} from './ContactScriptManifest.js';

/**
 * 
 * @export
 * @interface GetContactScriptsResponse
 */
export interface GetContactScriptsResponse {
    /**
     * 
     * @type {Array<ContactScriptManifest>}
     * @memberof GetContactScriptsResponse
     */
    data?: Array<ContactScriptManifest>;
    /**
     * 
     * @type {number}
     * @memberof GetContactScriptsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactScriptsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactScriptsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactScriptsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactScriptsResponse interface.
 */
export function instanceOfGetContactScriptsResponse(value: object): boolean {
    return true;
}

export function GetContactScriptsResponseFromJSON(json: any): GetContactScriptsResponse {
    return GetContactScriptsResponseFromJSONTyped(json, false);
}

export function GetContactScriptsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactScriptsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ContactScriptManifestFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactScriptsResponseToJSON(value?: GetContactScriptsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ContactScriptManifestToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

